module.exports = "/images/jcb.svg";